import Swal from 'sweetalert2/dist/sweetalert2.js'

export default function validateRegulatedCountries(data, locale) {
  if (!data || data.toTaiwan !== true) return true
  if (Array.isArray(data.regulated_countries) && data.regulated_countries.some(country => typeof country === 'string' && country.trim() !== '')) return true

  const messages = {
    'zh-TW': ['尚未選擇管制地區', '開啟管制地區後，請至少選擇一個國家才能進行下一步。'],
    'zh-CN': ['尚未选择管制地区', '开启管制地区后，请至少选择一个国家才能进行下一步。'],
    'en-US': ['Select a regulated country', 'Select at least one country before continuing when regulated regions are enabled.'],
  }
  const [title, text] = messages[locale] || messages['zh-TW']
  Swal.fire(title, text, 'warning')
  return false
}
